<div class="pre_1">
  <div class="banner text-center">
    <h2><span> YOU GET ONE LIFE. </span> MAKE IT worthy.</h2>
    <h1>We welcome you to experience the Unbelievable!</h1>
    <h3 style="color: white">You Are Invited By : {{ userName }} &nbsp;</h3>
  </div>
  <!--BANNER PART CLOSED-->

  <div class="container">
    <div class="welcome_box">
      <h1>Greetings <span> O-Founder</span></h1>
      <div class="wel_line"></div>
      <p>
        Build and expand your business. Work less and earn more <br />
        Replace and secure your income
      </p>
      <div class="read-more-button">
        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'regform'"
          class="read_more_button"
        >
          <!-- <a
          href="/registration/user?reg={{ referralId }}"
          target="_blank"
          rel="noopener"
          class="read_more_button"
        > -->
          BECOME A FOUNDER NOW
        </a>
      </div>
    </div>
  </div>

  <!--SECTION ONE PART OPEN-->
  <div class="sec_one_box">
    <div class="container">
      <div class="col-lg-6">
        <div class="sec_one_left_box">
          <h1>WIN BIG <span>IN 2019</span></h1>
        </div>
      </div>

      <div class="video_bg">
        <div class="sec_one_left_box">
          <h3>The concept of working and earning online is now a reality.</h3>
          <p>
            Enjoy long-term residual payments by harvesting the power of the
            Internet along with the right tools, best guidance and the perfect
            system that makes it happen.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="make_box">
    <a
      class="video-frame"
      data-toggle="modal"
      data-backdrop="static"
      data-keyboard="false"
      (click)="open(mymodal1)"
    >
      <img
        src="{{ myLinksS3URL }}frontend/greetingsgofound/images/video1.png"
        alt="video1"
        class="img-fluid"
      />
    </a>
  </div>

  <div class="carv_right_box">
    <div class="carv_right_box-inner">
      <h1>Enjoy the Goldmine of Residual Income for Life</h1>
      <p>Run your business in full auto-pilot mode with following benefits:</p>
      <ul>
        <li>
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/tick.png"
            alt="tick"
            class="img-fluid"
          />
          AUTOPILOT...ADVERTISING
        </li>
        <li>
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/tick.png"
            alt="tick"
            class="img-fluid"
          />AUTOPILOT....MARKETING
        </li>
        <li>
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/tick.png"
            alt="tick"
            class="img-fluid"
          />
          AUTOPILOT...LEADS
        </li>
        <li>
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/tick.png"
            alt="tick"
            class="img-fluid"
          />
          AUTOPILOT...SIGNUPS
        </li>
        <li>
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/tick.png"
            alt="tick"
            class="img-fluid"
          />AUTOPILOT....RECRUITING
        </li>
        <li>
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/tick.png"
            alt="tick"
            class="img-fluid"
          />
          AUTOPILOT...TEAM BUILDING
        </li>
      </ul>
      <div class="clearfix"></div>
      <div class="border-shape"></div>
    </div>

    <p>
      Get acquainted with our innovative business strategy, the greatest
      opportunity so far in the history of internet marketing.
    </p>

    <div class="clearfix"></div>
    <div class="read-more-button">
      <a
        [routerLink]="'.'"
        [queryParams]="{ reg: referralId }"
        [fragment]="'regform'"
        class="read_more_button"
      >
        BECOME A FOUNDER NOW
      </a>
    </div>
  </div>

  <!--SECTION THREE PART OPEN-->
  <div class="sec_second_bg">
    <div class="container">
      <div class="second_right_box">
        <h1>
          Do you believe in the power of the internet and the concept of working
          from home ?
        </h1>

        <div class="stratigy">
          <p class="mb-0">
            Our unique strategy gives you an opportunity to change your life for
            BETTER by gifting you:
          </p>
        </div>

        <div class="founder-ul">
          <ul>
            <li>No Requirements</li>
            <li>No Recruiting</li>
            <li>No Auto-ship</li>
            <li>No Monthly Fees</li>
          </ul>

          <div class="read-more-button">
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="read_more_button"
            >
              BECOME A FOUNDER NOW
            </a>
          </div>

          <div class="clearfix"></div>
        </div>
      </div>

      <div class="sec_second_left_box">
        <a
          class="right-s-video"
          data-toggle="modal"
          data-backdrop="static"
          data-keyboard="false"
          (click)="open(mymodal2)"
        >
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/video2.png"
            alt="video2"
            class="img-fluid"
          />
        </a>
      </div>
    </div>
  </div>

  <div class="sec_second-three_bg">
    <div class="container">
      <div class="">
        <!-- <h1 data-aos="fade-up">Why give an excuse, when you can be the change?</h1>
            <h6 data-aos="fade-left">Now You Just Have Two Options:</h6> -->
        <div class="why_first_box green-gradient">
          <div class="inner-text">
            <!-- <h1>1</h1>-->
            <div class="stratigy excuse">
              <p class="mb-0">Why join us now?</p>
            </div>
            <p>
              It takes only $97 to join us which otherwise costs $997. Yes! We
              are giving you 90% discount now as pre-launch offer. If you want
              to join us later, we cannot promise the availability of seats.
            </p>
          </div>

          <div class="border-shape"></div>
        </div>
      </div>
    </div>
  </div>

  <!--SECTION THREE PART CLOSED-->

  <!--SECTION THREE PART OPEN-->
  <div class="sec_three_bg">
    <div class="sec_three_left_box">
      <div class="register_text_box">
        <div class="reg_text">
          Register <br />
          <span>With Us Through These</span>
        </div>
        <span class="three_text">2</span>
        <span class="step_text">STEPS</span>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="steps">
              <div class="row align-items-center">
                <div class="steps-number">
                  <h2 class="aos-init aos-animate">1</h2>
                  <div class="steps-text">
                    <p>
                      Sign up using your basic details and fill up the
                      registration form.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="steps ml-text">
              <div class="row align-items-center">
                <div class="steps-number">
                  <h2 class="aos-init aos-animate">2</h2>
                  <div class="steps-text">
                    <p>
                      Pay us through your preferred payment mode and secure the
                      position
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="famly">
        <h1>
          Join us today and we promise that <span>you will never</span> regret
          the decision
        </h1>
      </div>
    </div>

    <div class="third_right_box">
      <div class="video_third_bg">
        <a
          href="javascript:void(0)"
          class="video-frame"
          data-toggle="modal"
          data-backdrop="static"
          data-keyboard="false"
          (click)="open(mymodal3)"
          data-target="#myModal3"
        >
          <img
            src="{{ myLinksS3URL }}frontend/greetingsgofound/images/video3.png"
            alt=""
            class="img-fluid"
          />
        </a>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>

  <!--SECTION THREE PART CLOSED-->

  <section class="inline-founder">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="read-more-button inline-founder-btn">
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="read_more_button"
            >
              BECOME A FOUNDER NOW</a
            >
          </div>
        </div>

        <div class="col-md-6 col-xs-12">
          <div class="carv_right_box-inner">
            <h2>
              No need to be a technical wizard. No need to have any technical
              ability.
            </h2>

            <p>
              Get your own page and invite your friends and family who dream big
              to secure their earnings. Gain knowledge from the regular updates
              sent by Mr.Mufareh in your backoffice. Be assured that the plans
              will be a big success as he has a wide network of loyal resources
              to assist him.
            </p>

            <div class="clearfix"></div>
            <div class="border-shape"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="webiner_bg">
    <div class="container">
      <h1>WEBINAR</h1>

      <a
        (click)="open(mymodal2)"
        class="webiner_bottom_box"
        data-toggle="modal"
        data-backdrop="static"
        data-keyboard="false"
        data-target="#previous"
      >
        <img
          src="{{
            myLinksS3URL
          }}frontend/greetingsgofound/images/play_button_two.png"
          alt="play"
        />
        PREVIOUS WEBINAR PLAYBACK
      </a>

      <div class="web_button_box">
        <!-- <a href="#" class="book_buton" data-aos="flip-left" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#book" >
        <div class="book_left_icon_box"><img src="{{ myLinksS3URL }}frontend/greetingsgofound/images/book_icon.jpg" alt="icon"></div>
        BOOK YOUR SEAT
      </a>-->

        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'regform'"
          class="book_buton"
        >
          <div class="book_left_icon_box">
            <img
              src="{{
                myLinksS3URL
              }}frontend/greetingsgofound/images/founder_icon.jpg"
              alt="icon"
            />
          </div>
          BECOME A FOUNDER
        </a>

        <!-- <a href="https://www.anymeeting.com/975-332-477"target="_blank" rel="noopener" class="book_buton" data-aos="flip-up">
         <div class="book_left_icon_box"><img src="{{ myLinksS3URL }}frontend/greetingsgofound/images/live_icon.jpg" alt="icon"></div>
         JOIN THE LIVE WEBINAR
        </a>-->
      </div>
    </div>
  </div>

  <!--REG PART OPEN-->
  <div class="reg_box">
    <div class="container">
      <div class="reg_main_box" id="regform">
        <div class="reg_left_bg">
          <h1>Welcome <span class="d-md-block">O-Founders</span></h1>
          <div class="border">
            <p>HURRY UP! Don’t let go of this massive opportunity</p>
            <ul>
              <li>3 X 10 FORCED MATRIX TO INFINITY</li>
              <li>INSTANT & DIRECT AUTOMATED PAYMENTS</li>
              <li>AUTOMATED SPILLOVERS & UPGRADES</li>
              <li>EVERYONE GETS PAID ON EVERYONE</li>
            </ul>
          </div>
          <h2>Change the game! Change your life</h2>
          <p><br /></p>
          <div class="sign_in">
            <a
              routerLink="/auth/login"
              class="sign_in_button"
              target="_blank"
              rel="noopener"
              >SIGN IN</a
            >
          </div>
        </div>

        <div class="reg_right_box">
          <div class="logo">
            <img
              src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
              alt="logo"
            />
          </div>
          <h1>REGISTER</h1>

          <!-- <div class="alert-success">
                                    <strong>Success!</strong>                                     </div> -->
          <div class="panel-group cst"></div>
          <div class="reg_form_box">
            <form [formGroup]="registerForm">
              <div class="row reg">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      class="log_in_fild"
                      placeholder="First Name"
                      formControlName="firstname"
                      required
                    /><br />
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'required'
                        ) && registerForm.controls['firstname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      First Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Last Name"
                      class="log_in_fild"
                      formControlName="lastname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'required'
                        ) && registerForm.controls['lastname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Last Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-block form-group">
                <input
                  matInput
                  type="text"
                  placeholder="Email Address"
                  class="log_in_fild"
                  formControlName="email"
                  required
                />
                <span
                  *ngIf="
                    registerForm.controls['email'].hasError('required') &&
                    registerForm.controls['email'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Email id Required.
                </span>
                <span
                  *ngIf="registerForm.controls['email'].hasError('pattern')"
                  class="failed-validation"
                  style="color: red"
                >
                  Please enter valid email.
                </span>
                <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                 class="failed-validation" style="color: red">
                  Email length sould be less than 100
                </span> -->
              </div>

              <div class="form-group d-block">
                <div class="password-block">
                  <input
                    matInput
                    placeholder="Password"
                    formControlName="password"
                    class="log_in_fild"
                    [type]="pwdToggle ? 'text' : 'password'"
                    required
                  />
                  <button
                    type="button"
                    class="password-icon"
                    (click)="pwdToggle = !pwdToggle"
                  >
                    <i
                      class="fal"
                      [ngClass]="{
                        'fa-eye': pwdToggle,
                        'fa-eye-slash': !pwdToggle
                      }"
                    ></i>
                  </button>
                </div>
                <span
                  *ngIf="
                    registerForm.controls['password'].hasError('required') &&
                    registerForm.controls['password'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Password Required
                </span>
                <span
                  *ngIf="registerForm.controls['password'].hasError('pattern')"
                  class="failed-validation"
                  style="color: red"
                >
                  Password should contain minimum 8 Characters and Atleast one
                  Uppercase, One Lowercase, one Number and one Special
                  Characters
                </span>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="d-block">
                    <input
                      matInput
                      type="text"
                      placeholder="Phone Number"
                      class="log_in_fild"
                      formControlName="phone"
                      onKeyPress="if(this.value.length==20) return false;"
                      onkeydown="return event.keyCode !== 69"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('required') &&
                        registerForm.controls['phone'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Phone number is required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['phone'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('minlength') ||
                        registerForm.controls['phone'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 6 and max 20 digits.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <select
                      formControlName="country_id"
                      required
                      class="log_in_fild"
                    >
                      <option value="">Select Country</option>
                      <option
                        *ngFor="let country of countriesList"
                        [value]="country.countryId"
                      >
                        {{ country.countryName }}
                      </option>
                    </select>
                    <span
                      *ngIf="
                        registerForm.controls['country_id'].hasError(
                          'required'
                        ) && registerForm.controls['country_id'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Plese Select Country
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <div class="d-flex">
                                                    <div class="capcha form-control position-relative">
                                                        <img [src]="imageCaptcha" style="width: 120px" />
                                                    </div>
                                                    <div class="capcha-img">
                                                        <i class="fa fa-refresh fa-lg" aria-hidden="true" (click)="regenerateCaptcha()"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <div class="main input-effect">
                                                    <input id="capcha" maxlength="5" name="capcha" type="text" formControlName="enteredCaptcha" placeholder=" Enter Captcha" class="form-control effect-19" required="required" />
                                                    <span *ngIf="
                          registerForm.controls['enteredCaptcha'].hasError(
                            'required'
                          ) && registerForm.controls['enteredCaptcha'].touched
                        " class="failed-validation" style="color: red">
                        Captcha Required
                      </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

              <div class="text-center">
                <button
                  mat-raised-button
                  type="submit"
                  (click)="submitRegister()"
                  [disabled]="registerForm.invalid"
                  class="ibtn w-100"
                >
                  SignUp
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--REG THREE PART CLOSED-->

  <!--TESTIMONIALS PART OPEN-->
  <div class="testimonials_box">
    <div class="container">
      <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide class="slider-item">
          <div class="testimonial">
            <div class="pic">
              <img src="{{ cloudFrontUrl }}uploads/t1.png" />
            </div>
            <div class="description">
              <p>
                Ash and this platform was introduced to me a little while ago
                and I immediately saw how it WILL solve more than one of my
                needs.
              </p>

              <p>
                His drive and passion for creating a platform to help everyone
                from seasoned marketers to the "little guy" helped solidify my
                belief Then learning how we benefit financially with optional
                starting points, makes this an ideal model for anyone with a
                business who needs advertising.
              </p>

              <p>
                Thank you Ash for your vision and help for so many people around
                the world.
              </p>
            </div>
            <div class="testimonial-profile">
              <h3 class="title">Tim Leach</h3>
              <!--    <span class="post">Web Developer</span>-->
            </div>
          </div>
        </ng-template>

        <ng-template carouselSlide class="slider-item">
          <div class="testimonial">
            <div class="pic">R</div>
            <div class="description">
              <p>
                I loved your "Confessions" videos! I appreciate your passion on
                educating others about Online Marketing. What you are doing, and
                how you are doing it will only elevate the respect people will
                have for our industry in the future.
              </p>

              <p>
                The "mindset" you always talk about is something that has really
                helped me. I view you as one of the honest voices in this
                industry.
              </p>
            </div>
            <div class="testimonial-profile">
              <h3 class="title">ROEM EMVERDA</h3>
              <!-- <span class="post">Web Designer</span> -->
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
  <!--TESTIMONIALS PART CLOSED-->

  <!--FOOTER PART OPEN-->
  <div id="footer">
    <div class="container">
      <div class="col-sm-6">
        <h6>FOR A LITTLE WHILE YET, FOUNDER POSITIONS ARE STILL AVAILABLE!</h6>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <!--FOOTER PART CLOSED-->

  <div class="clearfix"></div>
  <div class="copy-right">
    <div class="container">
      <div class="col-md-6">
        <p>Copyright &copy; 2022 All rights reserved | by O-Founders</p>
      </div>
    </div>
  </div>
</div>

<ng-template #mymodal1 let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <video
      class="w-100"
      controls
      preload="auto"
      poster="{{
        myLinksS3URL
      }}frontend/invitationfive/images/greeting1-new.png"
    >
      <source
        src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
        type="video/mp4"
      />
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
      </p>
    </video>
  </div>
</ng-template>

<ng-template #mymodal2 let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <video
      class="w-100"
      controls
      preload="auto"
      poster="{{ myLinksS3URL }}videos/title.jpg"
    >
      <source
        src="{{
          myLinksS3URL
        }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
        type="video/mp4"
      />
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
      </p>
    </video>
  </div>
</ng-template>

<ng-template #mymodal3 let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <video
      class="w-100"
      controls
      preload="auto"
      poster="{{
        myLinksS3URL
      }}frontend/invitationfive/images/greeting1-new.png"
    >
      <source
        src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
        type="video/mp4"
      />
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
      </p>
    </video>
  </div>
</ng-template>
